import { render, staticRenderFns } from "./vendors-echart.vue?vue&type=template&id=a98bf848&"
import script from "./vendors-echart.vue?vue&type=script&lang=js&"
export * from "./vendors-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports